import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";
import { apiServiceConstants } from "../../../../constants/apiService.constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";
import {
  FileShareFullListInterface,
  FileShareFullListModel,
  FileShareFullListResult,
  MediaItemForwardModel,
} from "./SelectUserComponent.model";

const getFileShareFullListDetails = async (
  params: any,searchedName:any
): Promise<FileShareFullListInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `media-share/user-add-list/?reg_code=${utilService.getNetwork()}&search_name=${searchedName}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareListResp = res as FileShareFullListModel;
      var resultData: any;
      if (fileShareListResp.result) {
        resultData = mapFileShareFullListResult(fileShareListResp.result);
      }
      const result: FileShareFullListInterface = {
        isSuccess: true,
        status: fileShareListResp.status,
        message: fileShareListResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: FileShareFullListInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getFileShareRecentFullListDetails = async (
  params: any,searchedName:string
): Promise<FileShareFullListInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/messages-user-add-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareListResp = res as FileShareFullListModel;
      var resultData: any;
      if (fileShareListResp.result) {
        resultData = mapFileShareFullListResult(fileShareListResp.result);
      }
      const result: FileShareFullListInterface = {
        isSuccess: true,
        status: fileShareListResp.status,
        message: fileShareListResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: FileShareFullListInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const mapFileShareFullListResult = (
  payload: Array<FileShareFullListResult>
) => {
  let resultListArray = payload.map((object: FileShareFullListResult) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: doctorsListService.setDoctorListModel(object.data),
    };
  });
  return resultListArray;
};

const forwardMediaListItem = async (
  params: any
): Promise<MediaItemForwardModel> => {
  const respApiResult = await apiService
    .apiCall(
      `media-share/media-upload/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareMediaListResp = res as MediaItemForwardModel;
      const result: MediaItemForwardModel = {
        isSuccess: true,
        status: fileShareMediaListResp.status,
        message: fileShareMediaListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: MediaItemForwardModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const forwardMedia = async (params: any): Promise<MediaItemForwardModel> => {
  const respApiResult = await apiService
    .apiCall(
      `user/forward-message/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareMediaListResp = res as MediaItemForwardModel;
      const result: MediaItemForwardModel = {
        isSuccess: true,
        status: fileShareMediaListResp.status,
        message: fileShareMediaListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: MediaItemForwardModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const handleErrorResponse = () => {};

export const FileShareListComponentService = {
  getFileShareFullListDetails,
  handleErrorResponse,
  getFileShareRecentFullListDetails,
  forwardMediaListItem,
  forwardMedia,
};
